import * as React from 'react'
import { useHandlers, useData } from './hooks'
import type { ENTITY_TYPES } from '@sales-center/common'
import { useFetchCallTrackingDetails } from './hooks'
import { CallTrackingField } from './CallTrackingField'
import { CallTrackingIcon } from '@sales-center/components'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'
type Props = {
  type: ENTITY_TYPES
  id: number
}

export function CallTrackingSectionContent(props: Props) {
  const { type, id } = props
  const { toggleShowEmpty, showEmpty } = useHandlers()
  const {
    infoLabel,
    callTrackingDetails,
    callTrackingState,
    callTrackingPhone,
    inProcess,
  } = useData()

  useFetchCallTrackingDetails(type, id)
  const theme = useTheme()
  return (
    <Stack p={2} pt={1.6}>
      <Box color="#1565c0" mb={2.8}>
        <Button
          size="medium"
          variant="text"
          href="https://app.calltrackingmetrics.com/calls"
          color="inherit"
          target="_blank"
          data-test-id="callTrackingMetricsButton"
        >
          <Box display="flex" alignItems="center">
            <CallTrackingIcon />
            <Typography fontFamily="Source Sans Pro SemiBold" ml={0.8}>
              CallTrackingMetrics
            </Typography>
          </Box>
        </Button>
      </Box>
      {!!infoLabel && (
        <Stack direction="row" borderRadius="4px" spacing={1.5} mb={3}>
          <Alert severity="info" sx={{ width: '100%' }}>
            <Typography variant="body2">{infoLabel}</Typography>
          </Alert>
        </Stack>
      )}
      {((!!callTrackingState && !infoLabel) || inProcess) && (
        <>
          <Stack direction="row" flexWrap="wrap">
            {callTrackingDetails.map((field) =>
              field?.fieldValue || showEmpty ? (
                <CallTrackingField
                  field={field}
                  callTrackingPhone={callTrackingPhone}
                  key={`callTrackingField_${field.id}`}
                />
              ) : null,
            )}
          </Stack>
          {callTrackingDetails.length > 0 && (
            <Box width="fit-content">
              <FormControlLabel
                control={<Switch onChange={toggleShowEmpty} size="small" />}
                label="Show empty fields"
                color={theme.palette.text.primary}
                data-test-id="showEmptyFieldsSwitch"
              />
            </Box>
          )}
        </>
      )}
    </Stack>
  )
}
